enum HistoryChangeType {
  IMPORT = "import",
  APPROVED = "approved",
}

export default HistoryChangeType
